import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import MenuList from 'src/components/widgets/MenuList';
import MenuWrapper from 'src/components/widgets/MenuWrapper';

import mainPageMenuItems from 'src/menuItems/mainPageMenuItems';

export default function MainPageMenu({ drawerMode }) {
  return (
    <Box
      pb={2}
      sx={{
        overflowX: 'hidden'
      }}
    >
      <MenuWrapper>
        {mainPageMenuItems.map((menu) => (
          <MenuList key={menu.title} menu={menu} drawerMode={drawerMode} />
        ))}
      </MenuWrapper>
    </Box>
  );
}

MainPageMenu.propTypes = {
  drawerMode: PropTypes.string
};
